import ReactDOM from 'react-dom';

import {
  ChangeEvent,
  FormEvent, useEffect, useRef, useState
} from 'react';
import { useOutside } from 'hooks/UseOutside';

import { toast } from 'react-toastify';

import { cepFormat } from 'utils/format';
import { addressApi } from 'services/api';

import { IAddressData } from 'pages/SendingDocuments/interfaces';
import { IAddressModalProps } from './interfaces';

import { ModalButton, ModalCloseButton, ModalContainer, ModalInput, ModalSection, ModalTitle } from './_addressModal';

export const AddressModal = ({
  toggleModal, setState, callback, setAddressChanged
}: IAddressModalProps) => {
  const modalRoot = document.getElementById('root-modal');
  const modalRef = useRef(null);

  const [disableForm, setDisableForm] = useState(true);
  const [hideModal, setHideModal] = useState(false);

  const [addressFormData, setAddressFormData] = useState({} as IAddressData)

  const handleCloseModal = () => {
    setHideModal((prevState) => !prevState);

    setTimeout(() => {
      toggleModal((prevState) => !prevState);

      if(callback){
        callback()
      }
    }, 500);
  }

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    switch (name) {
      case 'cep': {
        setAddressFormData((prevState) => ({
          ...prevState,
          cep: cepFormat(value)
        }))

        break;
      }
      default: {
        setAddressFormData((prevState) => ({
          ...prevState,
          [name]: value
        }))
      }
    }
  }

  const ensureAddressData = async () => {
    if(addressFormData?.cep && addressFormData?.cep?.length === 9){
      try {
        const response: any = await addressApi.get(`/${addressFormData?.cep}/json/`);

        setAddressFormData((prevState) => ({
          ...prevState,
          street: response?.data?.logradouro,
          neighborhood: response?.data?.bairro,
          city_ibge_code: response?.data?.ibge,
        }))
      } catch (error: any) {
        toast.error(error?.response?.data?.message);
      }
    }
  }

  const handleSaveData = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    setState(prevState => ({
      ...prevState,
      ...addressFormData,
    }))

    handleCloseModal()
    if(setAddressChanged) setAddressChanged(true);
  }

  useEffect(() => {
    handleFormValidate()
  }, [addressFormData])

  const handleFormValidate = () => {
    const formDataEntries = Object.values(addressFormData).filter(value => value !== '').length;

    if(formDataEntries >= 5) {
      setDisableForm(false)
    } else if (!disableForm) {
      setDisableForm(true)
    }
  }

  useOutside(modalRef, handleCloseModal);

  if(!modalRoot) {
    return null;
  }

  return ReactDOM.createPortal(
    <ModalSection className={`${hideModal ? 'modal-address--hide' : ''}`}>
      <ModalContainer
        onSubmit={handleSaveData}
        ref={modalRef}
      >
        <ModalCloseButton
          type="button"
          onClick={handleCloseModal}
        >
          X
        </ ModalCloseButton>
        <ModalTitle>
          Insira o endereço
        </ModalTitle>
        <ModalInput
          name="cep"
          placeholder="CEP"
          value={addressFormData.cep}
          onBlur={ensureAddressData}
          onChange={handleInputChange}
        />
        <ModalInput
          name="street"
          placeholder="Rua"
          value={addressFormData.street}
          onChange={handleInputChange}
        />
        <ModalInput
          name="neighborhood"
          placeholder="Bairro"
          value={addressFormData.neighborhood}
          onChange={handleInputChange}
        />
        <ModalInput
          name="number"
          placeholder="Número"
          value={addressFormData.number}
          onChange={handleInputChange}
        />
        <ModalInput
          name="complement"
          placeholder="Complemento"
          value={addressFormData.complement}
          onChange={handleInputChange}
        />
        <ModalButton
          type="submit"
          disabled={disableForm}
        >
          Confirmar
        </ModalButton>
      </ModalContainer>
    </ModalSection>
    ,modalRoot
  )
}
